import type {
  SearchMake,
  SearchModel,
  SearchResponse,
} from '@cinch-nx/data-search'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { fetchSearchVehicles } from '@retail-common/data-search-vehicles-api'
import type { VehicleCondition, VehiclesData } from '../../types/vehicles-data'

export const getVehiclesDataByCondition = async (
  vehicleCondition: VehicleCondition,
  byMonthlyPrice = true,
): Promise<{
  vehiclesData: VehiclesData
  searchResponse: SearchResponse
}> => {
  const data = await fetchSearchVehicles(readFromEnv(Env.SearchServiceUrl), {
    condition: [vehicleCondition],
    ...(byMonthlyPrice && {
      financeType: ['any'],
    }),
  })
  const searchResponse = data.response as unknown as SearchResponse

  const makesData = searchResponse.facets.makes
  const makes = makesData.map((make: SearchMake) => ({
    name: make.name,
    stock: make.doc_count,
    models: make.models.map((model: SearchModel) => ({
      name: model.name,
      stock: model.doc_count,
    })),
  }))

  const carTypes = {
    ...searchResponse.facets.bodyType,
    electric: searchResponse.facets.fuelType.electric,
  }
  const vehiclesData = {
    makes,
    carTypes,
    totalStock: searchResponse.searchResultsCount,
    monthlyPriceBucket: searchResponse.facets.monthlyPriceBucket,
    priceBucket: searchResponse.facets.priceBucket,
  }

  return { vehiclesData, searchResponse }
}
